import { Divider } from '@mui/material'

import { form } from '../../formState'
import * as Texts from '../../intl'
import { Props } from './typings'

import { PodAudios } from './components/PodAudios'
import { PodBarcodes } from './components/PodBarcodes'
import { PodNotes } from './components/PodNotes'
import { PodPictures } from './components/PodPictures'
import { PodSignatures } from './components/PodSignatures'

export function Pods(props: Props) {
  const { allowBarcodes } = props

  return (
    <form.Fieldset>
      <form.SectionTitle variant="alternative">{Texts.getPODTitle()}</form.SectionTitle>
      <PodNotes />
      <PodPictures {...props} />
      <PodSignatures {...props} />
      <PodAudios {...props} />
      <Divider />
      {allowBarcodes && <PodBarcodes {...props} />}
    </form.Fieldset>
  )
}
